<template>
  <card
      :loading="false"
      :maxWidth="'auto'"
      :width="'100%'"
      style="margin: 0;"
  >
    <div slot="title">Общее заключение</div>
    <div class="subtitle">Прикрепить комплекс упражнений для систем:</div>

    <div class="checkboxes" v-if="true">
      <div v-for="item of complexes" :key="item.id">
        <el-checkbox v-model="exercises" :label="item.id" class="checkboxes__item">{{ item.name }}</el-checkbox>
      </div>
    </div>

    <div class="bottom-subtitle">
      Заключение сформируется автоматически, после нажатия кнопки. Оно будет доступно для редактирования.
    </div>

    <el-button type="primary" :loading="loading" @click="generateConclusion">Сформировать заключение</el-button>

  </card>
</template>

<script>
import Card from "@/components/elements/Card.vue"
import {mapActions} from "vuex"

export default {
  name: "ChooseComplexExercise",
  components: {Card},
  data() {
    return {
      loading: false,
      exercises: []
    }
  },
  props: {
    complexes: {}
  },
  computed: {
    visitId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions({
      setActiveTab: "visit/SET_ACTIVE_TAB",
      loadConclusion: "visit/GENERATE_CONCLUSION",
    }),
    generateConclusion() {
      this.loading = true

      this.loadConclusion({visitId: this.visitId, data: {complex_exercises_id: this.exercises}}).then(() => {

        this.$notify.success({
          title: "Успешно",
          message: "Заключение создано",
        })

        document.querySelector('#scroll-session-block').scroll(0, 0)
        this.setActiveTab('conclusion')

      }).catch((response) => {

        this.$notify.error({
          title: "Ошибка",
          message: response.response.data.message
        })

      }).finally(() => {
        this.loading = false
      })

    }
  }
}

</script>
<style lang="scss" scoped>
.subtitle {
  margin-top: 12px;

  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  color: #111;

}

.bottom-subtitle {
  margin-top: 12px;
  margin-bottom: 12px;

  font-size: 11px;
  line-height: 13px;
  color: #111;

}

.checkboxes {
  margin-top: 12px;

  display: grid;
  grid-template-columns: repeat(auto-fit, 400px);

  &__item {
    padding: 0 5px;
  }

}
</style>